var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12178 14.7063C6.5124 15.0969 7.14678 15.0969 7.5374 14.7063L12.5374 9.70625C12.928 9.31563 12.928 8.68125 12.5374 8.29062C12.1468 7.9 11.5124 7.9 11.1218 8.29062L7.82803 11.5875V2C7.82803 1.44687 7.38115 1 6.82803 1C6.2749 1 5.82803 1.44687 5.82803 2V11.5844L2.53428 8.29375C2.14365 7.90312 1.50928 7.90312 1.11865 8.29375C0.728027 8.68437 0.728027 9.31875 1.11865 9.70938L6.11865 14.7094L6.12178 14.7063Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_806"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.828125 0H12.8281V16H0.828125V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cc3aa9680dea808d634363c245860670.svg";
export { ForwardRef as ReactComponent };